import R from "../../@babel/runtime/helpers/esm/extends.mjs";
import F from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import G from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import M from "../../@rc-component/trigger/es/index.mjs";
import * as v from "react";
import { forwardRef as _, useRef as j, useImperativeHandle as q } from "react";
import z from "./placements.mjs";
import B from "./Popup.mjs";
var J = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], K = function(o, f) {
  var y = o.overlayClassName, e = o.trigger, d = e === void 0 ? ["hover"] : e, i = o.mouseEnterDelay, C = i === void 0 ? 0 : i, r = o.mouseLeaveDelay, g = r === void 0 ? 0.1 : r, c = o.overlayStyle, t = o.prefixCls, a = t === void 0 ? "rc-tooltip" : t, b = o.children, h = o.onVisibleChange, V = o.afterVisibleChange, w = o.transitionName, D = o.animation, N = o.motion, n = o.placement, P = n === void 0 ? "right" : n, l = o.align, S = l === void 0 ? {} : l, p = o.destroyTooltipOnHide, x = p === void 0 ? !1 : p, E = o.defaultVisible, T = o.getTooltipContainer, A = o.overlayInnerStyle;
  o.arrowContent;
  var I = o.overlay, H = o.id, s = o.showArrow, L = s === void 0 ? !0 : s, k = G(o, J), m = j(null);
  q(f, function() {
    return m.current;
  });
  var u = F({}, k);
  "visible" in o && (u.popupVisible = o.visible);
  var O = function() {
    return /* @__PURE__ */ v.createElement(B, {
      key: "content",
      prefixCls: a,
      id: H,
      overlayInnerStyle: A
    }, I);
  };
  return /* @__PURE__ */ v.createElement(M, R({
    popupClassName: y,
    prefixCls: a,
    popup: O,
    action: d,
    builtinPlacements: z,
    popupPlacement: P,
    ref: m,
    popupAlign: S,
    getPopupContainer: T,
    onPopupVisibleChange: h,
    afterPopupVisibleChange: V,
    popupTransitionName: w,
    popupAnimation: D,
    popupMotion: N,
    defaultPopupVisible: E,
    autoDestroy: x,
    mouseLeaveDelay: g,
    popupStyle: c,
    mouseEnterDelay: C,
    arrow: L
  }, u), b);
};
const oo = /* @__PURE__ */ _(K);
export {
  oo as default
};
//# sourceMappingURL=Tooltip.mjs.map
